import {
    RichTextExtensionBlockquote,
    RichTextExtensionBold,
    RichTextExtensionBulletList,
    RichTextExtensionCode,
    RichTextExtensionCodeBlock,
    RichTextExtensionDocument,
    RichTextExtensionHardBreak,
    RichTextExtensionHeading,
    RichTextExtensionHistory,
    RichTextExtensionItalic, RichTextExtensionLink,
    RichTextExtensionListItem,
    RichTextExtensionOrderedList,
    RichTextExtensionParagraph,
    RichTextExtensionStrike,
    RichTextExtensionText
} from "@wix/devzai-utils-react";
import {Values} from "@wix/devzai-utils-common";

export const DoppeActionContentTipTapExtensions = [
    RichTextExtensionBlockquote, RichTextExtensionBold, RichTextExtensionBulletList,
    RichTextExtensionCode, RichTextExtensionCodeBlock, RichTextExtensionDocument, RichTextExtensionHardBreak,
    RichTextExtensionHeading, RichTextExtensionHistory, RichTextExtensionItalic, RichTextExtensionListItem,
    RichTextExtensionOrderedList, RichTextExtensionParagraph, RichTextExtensionStrike, RichTextExtensionText,
    RichTextExtensionLink.extend({
        inclusive: false
    }).configure({
        autolink: true,
        openOnClick: false,
        linkOnPaste: true,
        defaultProtocol: 'https',
    })
]


export const DoppeRichTextContentType = {
    DoppeActionContent: 'DoppeActionContent',
} as const;

export type DoppeRichTextContentType = Values<typeof DoppeRichTextContentType>;

export function doppeRichTextContentTypeResolveTipTapExtensions (contentType: DoppeRichTextContentType) {
    switch (contentType) {
        case DoppeRichTextContentType.DoppeActionContent: {
            return DoppeActionContentTipTapExtensions;
        }
    }
}

export function doppeRichTextContentTypeSupportsLinks (contentType: DoppeRichTextContentType) {
    switch (contentType) {
        case DoppeRichTextContentType.DoppeActionContent: {
            return true;
        }
    }
}